import SvgIcn from "../../data/IconCompo";
import { VALIDATION_ALERT_VARIANTS } from "../../data/validationAlertVariants";

/**
 * Static clones of ValidationPopup markup for styling. Does not use Redux.
 */
export default function ValidationAlertsGallery() {
  return (
    <div className="alert-style-lab">
      <p className="alert-style-lab__hint">
        Same markup and classes as live notifications (
        <code className="alert-style-lab__code">.tooltip.slide-down.[type]</code>
        ). Position is overridden so every variant stays visible.
      </p>
      <div className="alert-style-lab__grid">
        {VALIDATION_ALERT_VARIANTS.map((v) => (
          <div key={v.key} className="alert-style-lab__card">
            <div className="alert-style-lab__meta">
              <span className="alert-style-lab__type">{v.type}</span>
              <span className="alert-style-lab__icon">
                {v.icon ? (
                  <>
                    icon: <code>{v.icon}</code>
                  </>
                ) : (
                  <>no icon</>
                )}
              </span>
            </div>
            <div className="alert-style-lab__preview">
              <div
                className={`tooltip slide-down ${v.type} alert-style-lab__toast`}
              >
                {v.message}
                {v.icon ? <SvgIcn name={v.icon} /> : null}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
